(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-collection-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('.ft-cg__doors').forEach((nav) => {
        if (nav.dataset.scrollerReady) return;
        nav.dataset.scrollerReady = 'true';
        const rail = nav.querySelector('.ft-cg__rail');
        const buttons = [...nav.querySelectorAll('[data-ft-cg-scroll]')];
        if (!rail || buttons.length !== 2) return;
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          buttons.forEach((button) => {
            const previous = button.dataset.ftCgScroll === '-1';
            button.hidden = max <= 2;
            button.disabled = previous ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2;
          });
        };
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const card = rail.querySelector('.ft-cg__door');
            const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap || 0) : 196;
            const count = Math.max(1, Math.floor((rail.clientWidth - 80) / step));
            rail.scrollBy({
              left: Number(button.dataset.ftCgScroll) * step * count,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          });
        });
        rail.addEventListener('scroll', update, { passive: true });
        new ResizeObserver(update).observe(rail);
        update();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-concern-routine"]) return;
  try {
    
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-ft-concern-routine]').forEach((root) => {
        if (root.dataset.routineCartReady === 'true') return;
        root.dataset.routineCartReady = 'true';

        root.addEventListener('click', async (event) => {
          const textureToggle = event.target.closest('[data-ft-texture-toggle]');
          if (textureToggle) {
            event.stopPropagation();
            const media = textureToggle.closest('.ft-texture-media');
            const willShow = textureToggle.getAttribute('aria-pressed') !== 'true';
            root.querySelectorAll('[data-ft-texture-toggle][aria-pressed="true"]').forEach((toggle) => {
              toggle.setAttribute('aria-pressed', 'false');
              toggle.setAttribute('aria-label', toggle.dataset.showLabel || '');
              toggle.closest('.ft-texture-media')?.classList.remove('is-texture-visible');
            });
            if (willShow && media) {
              media.classList.add('is-texture-visible');
              textureToggle.setAttribute('aria-pressed', 'true');
              textureToggle.setAttribute('aria-label', textureToggle.dataset.hideLabel || '');
            }
            return;
          }

          const button = event.target.closest('[data-ft-routine-add]');
          if (!button || button.disabled) return;

          const status = root.querySelector('[data-ft-routine-status]');
          const ids = [...root.querySelectorAll('[data-ft-routine-item]')]
            .map((item) => Number(item.dataset.id))
            .filter((id) => Number.isInteger(id) && id > 0);
          const expected = Number(root.dataset.productCount || 0);

          if (ids.length !== expected || expected < 1) {
            if (status) status.textContent = root.dataset.unavailable || '';
            return;
          }

          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.setAttribute('aria-label', `${root.dataset.adding} — ${root.dataset.routineName}`);
          button.textContent = root.dataset.adding;
          if (status) status.textContent = root.dataset.adding;

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
            });
            if (!response.ok) throw new Error('cart');
          } catch (error) {
            if (status) status.textContent = root.dataset.error;
            button.disabled = false;
            button.removeAttribute('aria-busy');
            button.setAttribute('aria-label', `${root.dataset.add} — ${root.dataset.routineName}`);
            button.textContent = root.dataset.add;
            return;
          }

          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'ft_concern_routine_add_all',
              routine: root.dataset.routineName,
              collection: root.dataset.collection,
              product_count: ids.length
            });
          } catch (error) {
            /* The cart succeeded, so analytics must not prevent navigation. */
          }
          window.location.assign(`${window.Shopify.routes.root}cart`);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-pg-routines"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.ft-routines-page');
    if (!root || root.dataset.routineCartReady === 'true') return;
    root.dataset.routineCartReady = 'true';

    root.addEventListener('click', async event => {
      const textureToggle = event.target.closest('[data-ft-texture-toggle]');
      if (textureToggle) {
        event.stopPropagation();
        const media = textureToggle.closest('.ft-texture-media');
        const willShow = textureToggle.getAttribute('aria-pressed') !== 'true';
        root.querySelectorAll('[data-ft-texture-toggle][aria-pressed="true"]').forEach(toggle => {
          toggle.setAttribute('aria-pressed', 'false');
          toggle.setAttribute('aria-label', toggle.dataset.showLabel || '');
          toggle.closest('.ft-texture-media')?.classList.remove('is-texture-visible');
        });
        if (willShow && media) {
          media.classList.add('is-texture-visible');
          textureToggle.setAttribute('aria-pressed', 'true');
          textureToggle.setAttribute('aria-label', textureToggle.dataset.hideLabel || '');
        }
        return;
      }

      const button = event.target.closest('[data-ft-routine-add]');
      if (!button || button.disabled) return;

      const cart = button.closest('[data-ft-routine-cart]');
      const status = cart?.querySelector('[data-ft-routine-status]');
      const ids = [...(cart?.querySelectorAll('[data-ft-routine-item]') || [])]
        .map(item => Number(item.dataset.id))
        .filter(id => Number.isInteger(id) && id > 0);
      const expected = Number(cart?.dataset.productCount || 0);

      if (!cart || ids.length !== expected || expected < 1) {
        if (status) status.textContent = cart?.dataset.unavailable || '';
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-label', `${cart.dataset.adding} — ${cart.dataset.routineName}`);
      button.textContent = cart.dataset.adding;
      if (status) status.textContent = cart.dataset.adding;

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(id => ({ id, quantity: 1 })) })
        });
        if (!response.ok) throw new Error('cart');
      } catch (error) {
        if (status) status.textContent = cart.dataset.error;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.setAttribute('aria-label', `${cart.dataset.add} — ${cart.dataset.routineName}`);
        button.textContent = cart.dataset.add;
        return;
      }
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'ft_routine_add_all',
          routine: cart.dataset.routineName,
          product_count: ids.length
        });
      } catch (error) {
        /* The cart succeeded, so analytics must not prevent navigation. */
      }
      window.location.assign(`${window.Shopify.routes.root}cart`);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
